import React from 'react';
import './Contact.css';
import Footer from './Footer';

const Contact = () => {
  // Data with Live Google Map Embed Links
  const branches = [
    {
      id: 1,
      name: 'Warden Court',
      address: 'GoPT, Warden Court Building, Gowalia Tank, August Kranti Maidan, Kemps Corner, Mumbai',
      phone: '+91 8779167772',
      email: 'info@thegopt.com',
      mapSrc: "https://maps.google.com/maps?q=GO%20PT%2C%20Warden%20Court%20Building%2C%20Gowalia%20Tank%2C%20Mumbai&t=&z=15&ie=UTF8&iwloc=&output=embed"
    },
    {
      id: 2,
      name: 'Walkeshwar, Malabar Hills',
      address: 'GoPT, Om Vikas CHS, 107 A Walkeshwar Road, Mumbai 400006',
      phone: '+91 8369903928',
      email: 'info@thegopt.com',
      mapSrc: "https://maps.google.com/maps?q=GO%20PT%2C%20Om%20Vikas%20CHS%2C%20107%20A%20Walkeshwar%20Road%2C%20Mumbai&t=&z=15&ie=UTF8&iwloc=&output=embed"
    },
    {
      id: 3,
      name: 'Cuffe Parade',
      address: 'GoPT, 38/39, Maker Arcade, Cuff Parade, Mumbai 400005',
      phone: '+91 93261 86695',
      email: 'info@thegopt.com',
      mapSrc: "https://maps.google.com/maps?q=Shop%20No%2012%2C%20Maker%20Arcade%2C%20Cuff%20Parade%2C%20Mumbai&t=&z=15&ie=UTF8&iwloc=&output=embed"
    }
  ];

  return (
    <div className="contact-page">
      <div className="contact-container">

        {/* --- SECTION 1: VISIT US --- */}
        <section className="visit-us-section">
          <div className="section-header-cinematic">
            <span className="subtitle-tag">Our Locations</span>
            <h1 className="title-cinematic">Visit Us</h1>
          </div>

          <div className="branches-grid">
            {branches.map((branch) => (
              <div key={branch.id} className="branch-card">
                <div className="map-container">
                  <iframe
                    title={`Map of ${branch.name}`}
                    src={branch.mapSrc}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                <div className="branch-details">
                  <h3>{branch.name}</h3>
                  <div className="detail-row">
                    <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg></span> 
                    <span className="text">{branch.address}</span>
                  </div>
                  <div className="detail-row">
                    <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg></span> 
                    <span className="text">{branch.phone}</span>
                  </div>
                  <div className="detail-row">
                    <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg></span> 
                    <span className="text">{branch.email}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* --- SECTION 2: REACH OUT (Home Visit) --- */}
        <section className="reach-out-section">
          <div className="spotlight-bg"></div>

          <div className="reach-out-content">
            <div className="form-header">
              <h2 className="form-title">Home Visit</h2>
              <p className="form-subtitle">We come to you.</p>
            </div>

            <div className="home-visit-info">
              {/* Samip Gupta */}
              <div className="home-visit-card">
                <div className="home-visit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                </div>
                <div className="home-visit-details">
                  <div className="detail-row">
                    <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></span>
                    <div className="name-stack">
                      <span className="text home-visit-name">Samip Gupta(PT)</span>
                      <span className="physio-designation">Super Senior Therapist</span>
                    </div>
                  </div>
                  <div className="detail-row">
                    <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg></span>
                    <span className="text">+91 9870687943</span>
                  </div>
                </div>
                <a href="tel:+919870687943" className="call-now-btn">
                  Call Now <span className="btn-arrow">→</span>
                </a>
              </div>

              {/* Nilav Jadhav */}
              <div className="home-visit-card">
                <div className="home-visit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                </div>
                <div className="home-visit-details">
                  <div className="detail-row">
                    <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></span>
                    <div className="name-stack">
                      <span className="text home-visit-name">Nilav Jadhav(PT)</span>
                      <span className="physio-designation">Senior Therapist</span>
                    </div>
                  </div>
                  <div className="detail-row">
                    <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg></span>
                    <span className="text">+91 8879028840</span>
                  </div>
                </div>
                <a href="tel:+918879028840" className="call-now-btn">
                  Call Now <span className="btn-arrow">→</span>
                </a>
              </div>

              {/* Shivam Patel */}
              <div className="home-visit-card">
                <div className="home-visit-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                </div>
                <div className="home-visit-details">
                  <div className="detail-row">
                    <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></span>
                    <div className="name-stack">
                      <span className="text home-visit-name">Shivam Patel(PT)</span>
                      <span className="physio-designation">Senior Therapist</span>
                    </div>
                  </div>
                  <div className="detail-row">
                    <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg></span>
                    <span className="text">+91 9892442627</span>
                  </div>
                </div>
                <a href="tel:+919892442627" className="call-now-btn">
                  Call Now <span className="btn-arrow">→</span>
                </a>
              </div>
            </div>

            {/* --- CLINIC DIRECT CALL CARDS --- */}
            <div className="direct-call-header">
              <h3 className="direct-call-title">Clinic Direct Lines</h3>
              <p className="direct-call-subtitle">Call our clinics directly.</p>
            </div>

            <div className="direct-call-grid">
              {branches.map((branch) => (
                <div key={branch.id} className="home-visit-card clinic-call-card">
                  <div className="home-visit-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                  </div>
                  <div className="home-visit-details">
                    <div className="detail-row">
                      <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg></span>
                      <span className="text home-visit-name">{branch.name}</span>
                    </div>
                    <div className="detail-row">
                      <span className="icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg></span>
                      <span className="text">{branch.phone}</span>
                    </div>
                  </div>
                  <a href={`tel:${branch.phone.replace(/\s/g, '')}`} className="call-now-btn">
                    Call Now <span className="btn-arrow">→</span>
                  </a>
                </div>
              ))}
            </div>

            {/* --- SOCIAL STATUS BAR --- */}
            <div className="social-statusbar">
              <span className="social-label">Connect</span>

              <div className="social-icons-container">
                <a href="https://www.facebook.com/share/1CimFuQigr/" target="_blank" rel="noreferrer" className="social-icon facebook" aria-label="Facebook">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                  </svg>
                </a>
                <a href="https://instagram.com/thegopt" target="_blank" rel="noreferrer" className="social-icon instagram" aria-label="Instagram">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                </a>
                <a href="https://youtube.com/@dr.samphysio" target="_blank" rel="noreferrer" className="social-icon youtube" aria-label="YouTube">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path>
                    <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" fill="currentColor" stroke="none"></polygon>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;